console.log("TEXT IMAGE DUAL LOADED");

document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll("[data-ti-dual]").forEach((section) => {
    const overlayLayer = section.querySelector(".ti-dual__layer--overlay");
    const baseText = section.querySelector(".ti-dual__layer--base .ti-dual__content");
    const overlayText = section.querySelector(".ti-dual__layer--overlay .ti-dual__content");

    if (!overlayLayer) return;

    /* ÉTATS INITIAUX */
    gsap.set(overlayLayer, { xPercent: 100 });
    gsap.set(overlayText, { opacity: 0, y: 20 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=150%",
        scrub: true,
        pin: true,
        pinSpacing: true,
        // markers: true
      }
    });

    /* Pause de lecture */
    tl.to({}, { duration: 0.3 });

    /* Slide overlay */
    tl.to(overlayLayer, {
      xPercent: 0,
      ease: "none"
    });

    /* Texte base disparaît */
    if (baseText) {
      tl.to(baseText, {
        // opacity: 0,
        x: 10,
        ease: "power2.out"
      }, "<");
    }

    /* Texte overlay apparaît */
    if (overlayText) {
      tl.to(overlayText, {
        opacity: 1,
        y: 0,
        ease: "power3.out"
      }, "<+=0.1");
    }
  });
});






























// console.log("TEXT IMAGE DUAL LOADED");


// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   document.querySelectorAll("[data-ti-dual]").forEach((section) => {
//     const overlayLayer = section.querySelector(".ti-dual__layer--overlay");
//     const text = section.querySelector(".ti-dual__overlay");

//     if (!overlayLayer) return;

//     /* =========================
//        ÉTATS INITIAUX
//     ========================= */
//     gsap.set(overlayLayer, { xPercent: 100 });
//     if (text) gsap.set(text, { opacity: 0, y: 30 });

//     /* =========================
//        TIMELINE PINNÉE
//     ========================= */
//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: "top top",        // 👉 pin dès que la section touche le top
//         end: "+=150%",           // 👉 longueur du scroll pendant le pin
//         scrub: true,
//         pin: true,
//         pinSpacing: true,
//         markers: true            // enlève quand validé
//       }
//     });

//     /* =========================
//        1️⃣ TEMPS MORT (PIN SANS ANIM)
//     ========================= */
//     tl.to({}, { duration: 0.3 });

//     /* =========================
//        2️⃣ SLIDE OVERLAY
//     ========================= */
//     tl.to(overlayLayer, {
//       xPercent: 0,
//       ease: "none"
//     });

//     /* =========================
//        3️⃣ FADE TEXTE
//     ========================= */
//     if (text) {
//       tl.to(
//         text,
//         {
//           opacity: 1,
//           y: 0,
//           ease: "power3.out"
//         },
//         "<" // synchro avec le slide
//       );
//     }
//   });
// });


























// console.log("TEXT IMAGE DUAL LOADED");


// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   document.querySelectorAll("[data-ti-dual]").forEach((section) => {
//     const overlayLayer = section.querySelector(".ti-dual__layer--overlay");
//     const text = section.querySelector(".ti-dual__overlay");
//     if (!overlayLayer) return;

//     // ✅ état initial clair
//     gsap.set(overlayLayer, { xPercent: 100 });
//     if (text) gsap.set(text, { opacity: 0, y: 30 });

//     const tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: section,
//         start: "top+=25% 75%",
//         end: "bottom-=50% 50%",
//         scrub: true,
//         markers: true
//       }
//     });

//     // ✅ slide overlay de -100% -> 0
//     tl.to(overlayLayer, { xPercent: 0, ease: "none" }, 0);

//     // ✅ fade texte
//     if (text) {
//       tl.to(text, { opacity: 1, y: 0, ease: "power3.out" }, 0);
//     }
//   });
// });
